import { useState, useEffect } from 'react';

import { Box, Drawer, Grid, TextField, Button, Divider, Typography } from '@mui/material';

// Utils
import messages from '../../static/messages';

// Styles
import { button } from '../../static/theme-styles';

// External variables
const required_fields = ['description'];

const GuaranteeDrawer = (props) => {
  const { currentItem, setCurrentItem, createItem, updateItem } = props;
  const [errors, setErrors] = useState({});

  // Action functions
  const resetErrors = () => {
    setErrors({});
    required_fields.forEach((el) =>
      setErrors((prevState) => ({
        ...prevState,
        [el]: false,
      })),
    );
  };

  // Handler functions
  const handleClose = () => props.onCloseDrawer(resetErrors);

  const handleChange = (e) => {
    const key = e.target.name;
    const val = e.target.value;

    setCurrentItem((prevState) => ({
      ...prevState,
      [key]: val,
      isEdited: true,
    }));
  };

  const handleValidate = () => {
    resetErrors();

    required_fields.forEach((field) => {
      if (currentItem[field] === '' || currentItem[field] === null) {
        setErrors((prevState) => ({
          ...prevState,
          [field]: true,
        }));
      } else {
        setErrors((prevState) => ({
          ...prevState,
          [field]: false,
        }));
      }
    });
  };

  // Hooks
  useEffect(() => {
    required_fields.forEach((el) =>
      setErrors((prevState) => ({
        ...prevState,
        [el]: false,
      })),
    );
  }, []);

  useEffect(() => {
    if (currentItem?.isEdited) {
      !Object.values(errors).includes(true) && (props.isNewItem ? createItem() : updateItem());
    }
  }, [errors]);

  return (
    <Drawer anchor="right" open={props.drawer} onClose={handleClose}>
      <Box>
        {props.currentItem && (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h4" gutterBottom>
                {props.isNewItem ? 'Add New Guarantee' : 'Update Guarantee'}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <TextField
                type="number"
                name="price"
                label="Price"
                defaultValue={currentItem.price}
                fullWidth
                onChange={handleChange}
                helperText="Optional - leave 0 if no additional cost"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                required
                name="description"
                label="Description"
                multiline
                rows={4}
                defaultValue={currentItem.description}
                fullWidth
                onChange={handleChange}
                error={errors.description}
                helperText={errors.description && messages.errors.required_field}
              />
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid item xs={12}>
              <Button
                variant="contained"
                sx={{ ...button('primary', 'secondary'), mr: 3 }}
                disabled={!currentItem.isEdited}
                onClick={handleValidate}
              >
                {props.isNewItem ? 'Add New Guarantee' : 'Update Guarantee'}
              </Button>

              <Button variant="contained" onClick={handleClose} sx={button('secondary')}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        )}
      </Box>
    </Drawer>
  );
};

export default GuaranteeDrawer;

